<template>
<div class="page-reporte-cartas">
  <v-container>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </v-container>

  <v-container fluid fill-height>
    <v-row :justify="'center'" :align="'center'">
      <v-col sm='12'>
        <base-material-card color="primary" icon="library_books" title="Reporte de CFDI's" class="elevation-1 px-5 py-3">

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-container grid-list-md>
                <v-row>
                  <v-col sm="3" md="3" lg="2">
                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha De" color="secondary" prepend-icon="event" @blur="model.fecha_de = parse_date(model.fecha_de)" :rules="[rules.required, valida_fecha]">
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu1 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col sm="3" md="3" lg="2">
                    <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                      <template v-slot:activator="{ on }">
                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha A" color="secondary" prepend-icon="event" @blur="model.fecha_a = parse_date(model.fecha_a)" :rules="[rules.required, valida_fecha]">
                        </v-text-field>
                      </template>

                      <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                        <v-spacer />

                        <v-btn color="secondary" x-small @click="menu2 = false">
                          Cancelar
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col sm="3" md="3" lg="2">
                    <v-autocomplete v-model="model.tipo_cfdi" :items="tipo_cfdi" :hide-no-data="true" :hide-selected="true" item-text="text" item-value="id" label="Tipo de CFDI" :rules="[rules.required]"></v-autocomplete>
                  </v-col>
                  <v-col sm="3" md="3" lg="2">
                    <v-autocomplete v-model="model.tipo_estatus" :items="tipo_estatus" :hide-no-data="true" :hide-selected="true" item-text="text" item-value="id" label="Facturas" :rules="[rules.required]"></v-autocomplete>
                  </v-col>
                  <v-col sm="3" md="3" lg="2">
                    <v-text-field v-model="model.receptor" label="Receptor"></v-text-field>
                  </v-col>
                  <v-col sm="3" md="3" lg="1">
                    <v-text-field v-model="model.serie" label="Serie"></v-text-field>
                  </v-col>
                </v-row>

              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="model = clean_model()">
              <v-icon>cancel</v-icon> Limpiar Filtros
            </v-btn>
            <v-btn color="success" @click.native="generar_reporte()">
              <v-icon>done</v-icon> {{ "Generar Reporte" }}
            </v-btn>
          </v-card-actions>


        </base-material-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>

<script>
export default {
  components: {},
  mounted: function() {
    /*if (!this.verificaPermiso('catalogos.proveedores')) {
      this.$router.replace("AccessDenied").catch(() => {});
    }*/
  },
  created: async function() {
    await this.cargarEmisor();
    this.model = this.clean_model();
  },
  data() {
    return {
      url: 'https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte',
      // url: 'http://localhost:8000/carta_porte',
      emisor: '',
      menu1: false,
      menu2: false,
      tipo_cfdi: [{
        "id": 4,
        "text": "Todas"
      }, {
        "id": 1,
        "text": "Pagos"
      }, {
        "id": 2,
        "text": "Carta Porte"
      }, {
        "id": 3,
        "text": "Sin Complementos"
      }],
      tipo_estatus: [{
        "id": 1,
        "text": "Todas"
      }, {
        "id": 2,
        "text": "Vigentes"
      }, {
        "id": 3,
        "text": "Canceladas"
      }],
      isLoading: false,
      search: "",
      model_filters: "",

      tmp_fecha: "",
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/index"
        },
        {
          text: "Reportes",
          disabled: true,
          href: ""
        },
        {
          text: "CFDI's",
          disabled: true,
          href: ""
        }
      ],
      update: false,
      model: {},
      rules: {
        required: v => !!v || "Este campo es requerido",
        decimal: value => {
          const pattern = /^[\d]*(\.{0,1}[\d]*)$/;
          return pattern.test(value) || "Número decimal no válido";
        },
        entero: function(numero) {
          const pattern = /^[\d]*$/;
          return pattern.test(numero) || "Debe ser un número entero";
        },
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Correo electrónico no valido";
        },
        rfc: v =>
          (v && v.length >= 9 && v.length < 15) || "RFC debe tener al menos 9 caractéres y 14 caractéres"
      },
      items: []
    }
  },
  methods: {
    parse_date(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    valida_fecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    valida_time: function(time) {
      if (time != null && time.toString() != "") {
        if (time.toString().length != 5)
          return "Hora no valida1";
        if (!time.match(/^\d{2}:(?:[0-5]\d)$/))
          return "Hora no valida2";
        var time_arr = time.split(":");
        if (time_arr.length != 2) {
          return "Hora no valida3";
        } else {
          if (isNaN(time_arr[0]) || isNaN(time_arr[1])) {
            return "Hora no valida4";
          }
          if (parseInt(time_arr[0]) < 24 && parseInt(time_arr[1]) < 60) {
            return true;
          } else {
            return "Hora no valida5";
          }
        }
      }
      return true;

    },
    clean_model: function() {
      return {
        fecha_de: '',
        fecha_a: '',
        tipo_cfdi: '',
        tipo_estatus:2,
        receptor: '',
        cliente: this.emisor,
        serie: null

      };
    },
    generar_reporte: function() {
      if (this.$refs.form.validate()) {
        try {
          this.$root.$dialogLoader.show("Espere un momento por favor..");

          if(this.model.serie == null || this.model.serie == undefined || this.model.serie == "") {
            delete this.model.serie;
          }

          this.$axios
            .post(this.url + '/reporte_cfdi/', this.model, {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Allow": "POST",
              "cache-control": "no-cache"
            })
            .then(response => {
              var binary_string = atob(response.data)
              var len = binary_string.length;
              var bytes = new Uint8Array(len);
              for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
              }
              var b = bytes.buffer;

              let blob = new Blob([b], {
                  type: 'application/xml'
                }),
                url = window.URL.createObjectURL(blob);

              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = url;
              a.download = "Reporte_CFDI.xlsx";
              a.click();
              a.parentNode.removeChild(a);
            })
            .catch(error => {
              console.log(error);
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al generar el reporte. Intente nuevamente.",
                footer: ""
              });
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        } catch (error) {
          console.log("ERRORS: ", error);
        }
      }
    },
    cargarEmisor: async function() {
      let self = this;
      this.$root.$dialogLoader.show("Espere un momento por favor..");
      var params = {
        "filtros": {
          "uuid": this.$crypto.decrypted(this.$local_storage.get(this.$crypto.SHA256("uuid_empresa")))
        }
      };

      await this.$axios.post(this.url + "/administracion/list_empresas/", params)
        .then(res => {
          if (res.data.length > 0) {
            self.emisor = res.data[0].rfc;
          } else {
            self.$swal({
              type: "error",
              title: "Error",
              text: "No se encontro la empresa.",
              footer: "",
            });
          }
        })
        .catch(err => {
          self.$swal({
            type: "error",
            title: "Error",
            text: "Ocurrió un error al obtener los registros.",
            footer: "",
          });
          console.log(err);
        }).then(() => {
          self.$root.$dialogLoader.hide();
        });
    },
  }
}
</script>
